import { render, staticRenderFns } from "./TipoCargoFormComponent.vue?vue&type=template&id=f5373aa2&"
import script from "./TipoCargoFormComponent.vue?vue&type=script&lang=js&"
export * from "./TipoCargoFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports